import React from 'react'

export default function WebDev() {
  return (
    <div style={{display : 'flex' , justifyContent : 'center' , flexWrap : 'wrap' }} >

   <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/HTML5_logo_and_wordmark.svg/640px-HTML5_logo_and_wordmark.svg.png" alt="img" style={{width : '170px' , height : '150px' , margin : '20px'}} />

   <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3d/CSS.3.svg/1200px-CSS.3.svg.png" alt="img" style={{width : '170px' , height : '150px' , margin : '20px'}} />

<img src="https://i.pinimg.com/originals/98/0b/a0/980ba07956ccfdf81b5060b1795cdcad.png" alt="img" style={{width : '170px' , height : '150px' , margin : '20px'}} />

<img src="https://www.vhv.rs/dpng/d/590-5903330_reactjs-logo-react-js-transparent-icon-hd-png.png" alt="img" style={{width : '170px' , height : '150px' , margin : '20px'}} />

<img src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Node.js_logo.svg/2560px-Node.js_logo.svg.png" alt="img" style={{width : '170px' , height : '150px' , margin : '20px'}} />

<img src="https://w7.pngwing.com/pngs/212/722/png-transparent-web-development-express-js-javascript-software-framework-laravel-world-wide-web-purple-blue-text.png" alt="img" style={{width : '170px' , height : '150px' , margin : '20px'}} />

<img src="https://mpng.subpng.com/20180824/ktx/kisspng-mysql-workbench-computer-icons-logo-portable-netwo-thezedt-tech-tips-and-random-thoughts-5b80352110ca84.1955496015351288650688.jpg" alt="img" style={{width : '170px' , height : '150px' , margin : '20px'}} />

<img src="https://cdn.iconscout.com/icon/free/png-256/sequelize-3-1175091.png" alt="img" style={{width : '170px' , height : '150px' , margin : '20px'}} />


   </div>

  )
}
